const getMaskId = (layer, height, width) => `mask-${layer}-${width}-${height}`

export default getMaskId
